import PropTypes from 'prop-types';
import React from 'react';
import Spinner from 'react16-spinjs';
import FullPageLayout from '../layouts/fullPageLayout';
import { SPINNER } from '../../constants/components';

const LoadingPage = props => (
    <div className="lantern-container">
        <div>
            <FullPageLayout>
                <Spinner config={props.spinnerConfig} />
            </FullPageLayout>
        </div>
    </div>
);

LoadingPage.propTypes = {
    spinnerConfig: PropTypes.object,
};

LoadingPage.defaultProps = {
    spinnerConfig: SPINNER.DEFAULT,
};

export default LoadingPage;
